import React, { useState } from 'react';
import { X, ShieldCheck } from 'lucide-react';
import { GoogleSignInButton } from './GoogleSignInButton';

// 訪客用完免費試用（或想儲存行程／用 AI 助手修改）時彈出，只提供 Google 登入。
// 刻意不放電郵註冊表格：一鍵登入、不問電話，減少「似詐騙網站」的疑慮。
const TXT = {
  'zh-HK': {
    trial_used: ['你已用完免費試用', '用 Google 登入即可繼續，每日免費生成 3 次行程。'],
    quota_full: ['今日免費試用名額已滿', '用 Google 登入即可繼續，每日免費生成 3 次行程。'],
    save:       ['登入以儲存這個行程', '用 Google 登入後，這個行程會自動存入你的帳戶。'],
    robot:      ['登入以使用 AI 助手修改行程', '用 Google 登入即可用 AI 助手調整行程，每日免費生成 3 次。'],
    days:       ['登入以規劃超過 4 天的行程', '未登入最多可規劃 4 天。用 Google 登入即可規劃最多 7 天，每日免費生成 3 次。'],
    trust: ['只會取得你的名字、電郵和頭像', '不會要求付款、電話號碼或信用卡', '不會代你在 Google 發佈任何內容'],
    email: '已有電郵帳戶？用電郵登入',
  },
  'zh-CN': {
    trial_used: ['你已用完免费试用', '用 Google 登录即可继续，每日免费生成 3 次行程。'],
    quota_full: ['今日免费试用名额已满', '用 Google 登录即可继续，每日免费生成 3 次行程。'],
    save:       ['登录以储存这个行程', '用 Google 登录后，这个行程会自动存入你的账户。'],
    robot:      ['登录以使用 AI 助手修改行程', '用 Google 登录即可用 AI 助手调整行程，每日免费生成 3 次。'],
    days:       ['登录以规划超过 4 天的行程', '未登录最多可规划 4 天。用 Google 登录即可规划最多 7 天，每日免费生成 3 次。'],
    trust: ['只会取得你的名字、电邮和头像', '不会要求付款、电话号码或信用卡', '不会代你在 Google 发布任何内容'],
    email: '已有电邮账户？用电邮登录',
  },
  'en': {
    trial_used: ["You've used your free try", 'Continue with Google to keep going — 3 free itineraries every day.'],
    quota_full: ["Today's free trial spots are full", 'Continue with Google to keep going — 3 free itineraries every day.'],
    save:       ['Sign in to save this trip', "Continue with Google and this trip will be saved to your account automatically."],
    robot:      ['Sign in to edit with the AI assistant', 'Continue with Google to tweak your trip with the AI assistant — 3 free itineraries every day.'],
    days:       ['Sign in to plan more than 4 days', 'Without signing in you can plan up to 4 days. Continue with Google for trips up to 7 days — 3 free itineraries every day.'],
    trust: ['We only get your name, email and profile photo', 'No payment, phone number or credit card needed', 'We never post anything to your Google account'],
    email: 'Have an email account? Sign in with email',
  },
  'ja': {
    trial_used: ['無料お試しを使い切りました', 'Google でログインすると続けて利用でき、1 日 3 回まで無料で旅程を作成できます。'],
    quota_full: ['本日の無料お試し枠は終了しました', 'Google でログインすると続けて利用でき、1 日 3 回まで無料で旅程を作成できます。'],
    save:       ['ログインしてこの旅程を保存', 'Google でログインすると、この旅程が自動的にアカウントに保存されます。'],
    robot:      ['ログインして AI アシスタントで編集', 'Google でログインすると AI アシスタントで旅程を調整できます（1 日 3 回まで無料）。'],
    days:       ['ログインして 4 日を超える旅程を作成', 'ログインなしでは最大 4 日まで。Google でログインすると最大 7 日の旅程を作成できます（1 日 3 回まで無料）。'],
    trust: ['取得するのは名前・メールアドレス・プロフィール写真のみ', '支払い・電話番号・クレジットカードは不要', 'Google アカウントに投稿することはありません'],
    email: 'メールアカウントをお持ちの方はこちら',
  },
  'ko': {
    trial_used: ['무료 체험을 모두 사용했습니다', 'Google로 계속하면 하루 3회 무료로 일정을 생성할 수 있습니다.'],
    quota_full: ['오늘의 무료 체험 인원이 마감되었습니다', 'Google로 계속하면 하루 3회 무료로 일정을 생성할 수 있습니다.'],
    save:       ['로그인하여 이 일정 저장', 'Google로 계속하면 이 일정이 계정에 자동 저장됩니다.'],
    robot:      ['로그인하여 AI 도우미로 수정', 'Google로 계속하면 AI 도우미로 일정을 조정할 수 있습니다（하루 3회 무료）.'],
    days:       ['로그인하여 4일 넘는 일정 계획', '로그인하지 않으면 최대 4일까지 가능합니다. Google로 계속하면 최대 7일 일정을 만들 수 있습니다（하루 3회 무료）.'],
    trust: ['이름, 이메일, 프로필 사진만 가져옵니다', '결제, 전화번호, 신용카드가 필요 없습니다', 'Google 계정에 어떤 것도 게시하지 않습니다'],
    email: '이메일 계정이 있으신가요? 이메일로 로그인',
  },
};

export const GuestGoogleGate = ({ reason, lang = 'zh-HK', onClose, onLogin, onEmailLogin }) => {
  const [err, setErr] = useState('');
  const L = TXT[lang] || TXT['en'];
  const [title, sub] = L[reason] || L.trial_used;
  return (
    <div style={{ position:'fixed', inset:0, zIndex:300, display:'flex', alignItems:'center', justifyContent:'center', background:'rgba(0,0,0,0.55)', backdropFilter:'blur(8px)', padding:16 }}
         onClick={e => { if (e.target === e.currentTarget) onClose(); }}>
      <div role="dialog" aria-modal="true" style={{ width:'100%', maxWidth:400, background:'white', borderRadius:22, overflow:'hidden', position:'relative' }}>
        <button aria-label="關閉" onClick={onClose} style={{ position:'absolute', top:12, right:12, width:30, height:30, borderRadius:'50%', background:'rgba(255,255,255,0.2)', border:'none', display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer' }}><X size={14} color="white"/></button>
        <div style={{ background:'linear-gradient(135deg,#0f172a,#1e3a5f)', padding:'26px 24px 22px', textAlign:'center' }}>
          <span style={{ fontSize:40 }}>🗺</span>
          <p style={{ margin:'10px 0 6px', fontSize:18, fontWeight:900, color:'white' }}>{title}</p>
          <p style={{ margin:0, fontSize:12.5, color:'rgba(255,255,255,0.75)', lineHeight:1.6 }}>{sub}</p>
        </div>
        <div style={{ padding:'20px 22px 18px', display:'flex', flexDirection:'column', gap:14 }}>
          <GoogleSignInButton lang={lang} onLogin={onLogin} onError={setErr}/>
          {err && <p style={{ fontSize:11, color:'#dc2626', textAlign:'center', margin:0 }}>{err}</p>}
          <div style={{ background:'#f8fafc', borderRadius:12, padding:'10px 14px', display:'flex', flexDirection:'column', gap:6 }}>
            {L.trust.map((line, i) => (
              <div key={i} style={{ display:'flex', alignItems:'center', gap:8 }}>
                <ShieldCheck size={14} color="#16a34a" style={{ flexShrink:0 }}/>
                <span style={{ fontSize:11.5, color:'#475569' }}>{line}</span>
              </div>
            ))}
          </div>
          <button onClick={onEmailLogin} style={{ background:'none', border:'none', color:'#94a3b8', fontSize:11.5, fontWeight:700, cursor:'pointer', textDecoration:'underline' }}>{L.email}</button>
        </div>
      </div>
    </div>
  );
};
